import axios from 'axios';

export const getGlobalMapChoices = async (choiceType) => {
  const url = `/reports/global-map/choices/${choiceType}/`;
  const response = await axios.get(url);
  return response;
};

export const getTeamChoices = async () => {
  return getGlobalMapChoices('team-id');
};

export const getInternalIdChoices = async () => {
  return getGlobalMapChoices('internal-id');
};

export const getImsmaIdChoices = async () => {
  return getGlobalMapChoices('imsma-id');
};

export const getRegionChoices = async () => {
  return getGlobalMapChoices('region');
};

export const getDistrictChoices = async () => {
  return getGlobalMapChoices('district');
};

export const getLocalCommunityChoices = async () => {
  return getGlobalMapChoices('local-community');
};

export const getSettlementChoices = async () => {
  return getGlobalMapChoices('settlement-name');
};

export const getTeamAutocomplete = async () => {
  return getTeamChoices();
};

export const getInternalIdAutocomplete = async () => {
  return getInternalIdChoices();
};

export const getImsmaIdAutocomplete = async () => {
  return getImsmaIdChoices();
};

export const getRegionAutocomplete = async () => {
  return getRegionChoices();
};

export const getDistrictAutocomplete = async () => {
  return getDistrictChoices();
};

export const getLocalCommunityAutocomplete = async () => {
  return getLocalCommunityChoices();
};

export const getSettlementAutocomplete = async () => {
  return getSettlementChoices();
};
